// redux/actionDispatcher/categoryDispatcher.js
// export const addCategoryRequest = (data) => {
//     return {
//       type: "ADD_CATEGORY_REQUEST",
//       payload: data,
//     };
//   };

import { ApiURLs, imageBaseUrls } from "../../../constant/ApiUrls";
import { deleteData, fetchData, postData, updateData, uploadImage } from "../../../services/api";
import { hideAddCategoryModal, hideAddKeywordModal } from "./categoryModalDispatcher";



export const addCategoryRequest = (data, navigate) => {
  return async (dispatch) => {

    // dispatch();
    dispatch({ "type": "ADD_CATEGORY_REQUEST" });
    try {

      if (data.image) {
        var uploadedImage = await uploadImage(
          ApiURLs.UPLOAD_IMAGE, "image",

          data.image,
          "category"
        );
        console.log(`upload image function response ${JSON.stringify(uploadedImage)}`)
        data.image = uploadedImage.data.file.filename
      }
      if (data.id) {

      }
      var categoryResponse = (data.id) ? await updateData(data, `${ApiURLs.CATEGORIES}/${data.id}`) : await postData(data, ApiURLs.CATEGORIES);
      if (categoryResponse.status === 1) {
        dispatch({ "type": "ADD_CATEGORY_SUCCESS" });
        dispatch(hideAddCategoryModal());
        dispatch(categoryLisitingRequest(data["parent_id"]));
      } else {
        dispatch({ "type": "ADD_CATEGORY_FAILED" });
      }
    } catch (error) {
      dispatch({ "type": "ADD_CATEGORY_FAILED" });

    }
  };
};






export const categoryLisitingRequest = (parentId, loadCategoryDetails = false) => {
  // console.log('000000000000000000',sortField,sortOrder);

  return async (dispatch) => {



    if (parentId !== 0 && loadCategoryDetails === true) {
      const url1 = `${ApiURLs.CATEGORIES}?id=${parentId}`;
      try {
        var categoryResponse = await fetchData(url1);
        dispatch({ "type": "GOT_CATEGORY_DETAIL", "payload": categoryResponse.data.result[0] });
        console.log("category response-------", categoryResponse);
      }
      catch (e) {

      }
    }
    else {
      console.log("000000000000000000000", parentId, loadCategoryDetails);
      if (parentId === 0) {
        dispatch({ "type": "GOT_CATEGORY_DETAIL", "payload": null });
      }
      else {

      }
    }
    // const url = ApiURLs.GET_USERS;
    const url = `${ApiURLs.CATEGORIES}?parent_id=${parentId}`;

    // wait untill the data not received so getData function take data and url part
    dispatch({ "type": "GET_CATEGORY_REQUEST" });
    try {
      var userResData = await fetchData(url);
      console.log(`response when we try to login ${JSON.stringify(userResData)}`)
      if (userResData.status === 1) {
        dispatch({ "type": "GET_CATEGORY_REQUEST_SUCCESS", "payload": userResData.data.result });

      } else {
        dispatch({ "type": "GET_CATEGORY_REQUEST_FAILED" });
      }
    } catch (error) {
      dispatch({ "type": "GET_CATEGORY_REQUEST_FAILED" });
      console.log(`error while try to login ${error}`)
    }
  }
};






export const addKeywordRequest = (data, navigate) => {
  return async (dispatch) => {

    // dispatch();
    dispatch({ "type": "ADD_KEYWORD_REQUEST" });
    try {

      var categoryResponse = await postData(data, ApiURLs.KEYWORDS);
      if (categoryResponse.status === 1) {
        dispatch({ "type": "ADD_KEYWORD_SUCCESS" });
        dispatch(hideAddKeywordModal());
        dispatch(keywordLisitingRequest(data["category_id"]));
      } else {
        dispatch({ "type": "ADD_KEYWORD_FAILED" });
      }
    } catch (error) {
      dispatch({ "type": "ADD_KEYWORD_FAILED" });

    }
  };
};

export const addBulkKeywordRequest = (data,) => {
  return async (dispatch) => {
    dispatch({ "type": "ADD_KEYWORD_REQUEST" });
    try {
      console.log(`Add BULK DATA  1 ${data}`)


      if (data.file) {
        var uploadedFile = await uploadImage(
          ApiURLs.UPLOAD_IMAGE, "image",
          data.file,
          "keyword"
        );
        console.log(`Add BULK DATA   2 ${JSON.stringify(uploadedFile)}`)

        data.csvUrl = `${imageBaseUrls(uploadedFile.data.file.filename)}`
      }
      // data.csvUrl = 'https://development-api.listit.im/assets/images/keyword/1762847776532-PC_Computer_Keywords.csv';


      console.log(`Add BULK DATA  3 ${data}`)

      var keywordBulkResponse = await postData(data, ApiURLs.KEYWORDSBULK);
      console.log(`Add BULK DATA  4 ${keywordBulkResponse}`)

      if (keywordBulkResponse.status === 1) {
        dispatch({ "type": "ADD_KEYWORD_SUCCESS" });
        dispatch(keywordLisitingRequest(data["category_id"]));
        dispatch(hideAddKeywordModal());

      } else {
        dispatch({ "type": "ADD_KEYWORD_FAILED" });
      }
    } catch (error) {
      dispatch({ "type": "ADD_KEYWORD_FAILED" });

    }
  };
};



export const keywordLisitingRequest = (parentId,) => {

  return async (dispatch) => {
    const url = `${ApiURLs.KEYWORDS}?category_id=${parentId}`;

    // wait untill the data not received so getData function take data and url part
    dispatch({ "type": "GET_KEYWORD_REQUEST" });
    try {
      var userResData = await fetchData(url);
      console.log(`response when we try to login ${JSON.stringify(userResData)}`)
      if (userResData.status === 1) {
        dispatch({ "type": "GET_KEYWORD_REQUEST_SUCCESS", "payload": userResData.data });

      } else {
        dispatch({ "type": "GET_KEYWORD_REQUEST_FAILED" });
      }
    } catch (error) {
      dispatch({ "type": "GET_KEYWORD_REQUEST_FAILED" });
      console.log(`error while try to login ${error}`)
    }
  }
};


export const getCategoryLisiting = () => {

  return async (dispatch) => {
    const url = `${ApiURLs.CATEGORIES}`;
    try {
      var userResData = await fetchData(url);
      console.log(`response when we try to get category ${JSON.stringify(userResData)}`)
      if (userResData.status === 1) {
        return userResData.data.result;

      } else {
        return [];
      }
    } catch (error) {
      console.log(`error while try to category ${error}`)

      return [];
    }
  }
};







export const getSubcategoriesRequest = (categoryId) => {
  return async (dispatch) => {
    dispatch({ type: "GET_SUBCATEGORY_REQUEST", payload: categoryId });

    try {
      const url = `${ApiURLs.CATEGORIES}?categoryId=${categoryId}`;
      var subcategoryRes = await fetchData(url);

      if (subcategoryRes.status === 1) {
        dispatch({
          type: "GET_SUBCATEGORY_SUCCESS",
          payload: { categoryId, subcategories: subcategoryRes.data.result },
        });
      } else {
        dispatch({
          type: "GET_SUBCATEGORY_FAILED",
          payload: categoryId,
        });
      }
    } catch (error) {
      dispatch({
        type: "GET_SUBCATEGORY_FAILED",
        payload: categoryId,
      });
      console.log(`Error while fetching subcategories: ${error}`);
    }
  };
};




export const deleteCategory = (id, parentId) => {
  return async (dispatch) => {

    // dispatch();
    dispatch({ "type": "ADD_CATEGORY_REQUEST" });
    try {


      var categoryResponse = await deleteData(`${ApiURLs.CATEGORIES}/${id}`);
      if (categoryResponse.status === 1) {
        dispatch({ "type": "ADD_CATEGORY_SUCCESS" });
        dispatch(categoryLisitingRequest(parentId));
      } else {
        dispatch({ "type": "ADD_CATEGORY_FAILED" });
      }
    } catch (error) {
      dispatch({ "type": "ADD_CATEGORY_FAILED" });

    }
  };
};



export const deleteKeyword = (id, parentId) => {
  return async (dispatch) => {

    // dispatch();
    dispatch({ "type": "ADD_KEYWORD_REQUEST" });
    try {


      var categoryResponse = await deleteData(`${ApiURLs.KEYWORDS}/${id}`);
      if (categoryResponse.status === 1) {
        dispatch({ "type": "ADD_KEYWORD_SUCCESS" });
        dispatch(keywordLisitingRequest(parentId));
      } else {
        dispatch({ "type": "ADD_KEYWORD_FAILED" });
      }
    } catch (error) {
      dispatch({ "type": "ADD_KEYWORD_FAILED" });

    }
  };
};



